import { MAKE_MODEL_YEAR, MAKE_YEAR_MODEL, YEAR_MAKE_MODEL } from "component/vehicle-form/constants";

function getFocusEl(selectionOrder: any, values: any) {
  const {
    defaultMake, defaultModel, defaultYear, attributeOptions, nextAttribute,
  } = values;

  if (attributeOptions?.length) {
    return nextAttribute;
  }

  if (!defaultMake && !defaultModel && !defaultYear) {
    return selectionOrder[0];
  }
  if (defaultMake && selectionOrder.toString() === MAKE_MODEL_YEAR.toString()) {
    return !defaultModel ? selectionOrder[1] : selectionOrder[2];
  }
  if (defaultMake && selectionOrder.toString() === MAKE_YEAR_MODEL.toString()) {
    return !defaultYear ? selectionOrder[1] : selectionOrder[2];
  }
  if (defaultYear && selectionOrder.toString() === YEAR_MAKE_MODEL.toString()) {
    return !defaultMake ? selectionOrder[1] : selectionOrder[2];
  }
  return selectionOrder[0];
}

export default getFocusEl;
